import { render, staticRenderFns } from "./PercepcionEst.vue?vue&type=template&id=24493086"
import script from "./PercepcionEst.vue?vue&type=script&lang=js"
export * from "./PercepcionEst.vue?vue&type=script&lang=js"
import style0 from "./PercepcionEst.vue?vue&type=style&index=0&id=24493086&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports